// export const API_KEY = process.env.REACT_APP_WEATHER_API_KEY;
// export const API_KEY = process.env.REACT_APP_WEATHER_API_KEY2;
export const API_KEY = process.env.REACT_APP_WEATHER_API_KEY3;
// export const API_KEY = process.env.REACT_APP_WEATHER_API_KEY4;
// export const API_KEY = process.env.REACT_APP_WEATHER_API_KEY5;
// export const API_KEY = process.env.REACT_APP_WEATHER_API_KEY6;
// export const API_KEY = process.env.REACT_APP_WEATHER_API_KEY7;
// export const API_KEY = process.env.REACT_APP_WEATHER_API_KEY8;
// export const API_KEY = process.env.REACT_APP_WEATHER_API_KEY9;

export const FAVORITES_LOCAL_STORAGE = 'favoriteCities';
export const THEME_LOCAL_STORAGE = 'theme';
export const TEMPERATURE_LOCAL_STORAGE = 'temperature';
